
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"var(--primary)","d":"M208 80H32a8 8 0 00-8 8v48a96.3 96.3 0 0032.54 72H32a8 8 0 000 16h176a8 8 0 000-16h-24.54a96.6 96.6 0 0027-40.09A40 40 0 00248 128v-8a40 40 0 00-40-40m24 48a24 24 0 01-17.2 23 96 96 0 001.2-15V97.38A24 24 0 01232 120zM112 56V24a8 8 0 0116 0v32a8 8 0 01-16 0m32 0V24a8 8 0 0116 0v32a8 8 0 01-16 0m-64 0V24a8 8 0 0116 0v32a8 8 0 01-16 0"}})])
          )
        }
      }
    